import { ScreenKey } from '@/Enums/Screens/ScreenKey.enum';
import { IProps as IIconProps } from '@/Interfaces/Icons/Props.interface';
import BrowserIcon from '@/components/Icons/BrowserIcon';
import BuildingIcon from '@/components/Icons/BuildingIcon';
import ChangeLogHistoryIcon from '@/components/Icons/ChangeLogHistoryIcon';
import CreativeLibraryIcon from '@/components/Icons/CreativeLibraryIcon';
import FirstPartyDataIcon from '@/components/Icons/FirstPartyDataIcon';
import MegaphoneIcon from '@/components/Icons/MegaphoneIcon';
import StatusUp from '@/components/Icons/StatusUp';
import Tag from '@/components/Icons/Tag';
import TargetIcon from '@/components/Icons/TargetIcon';
import TaskDaily from '@/components/Icons/TaskDaily';
import TvFilledIcon from '@/components/Icons/TvFilledIcon';
import UserIcon from '@/components/Icons/UserIcon';
import UserManagementRouteIcon from '@/components/Icons/UserManagementRouteIcon';
import WhitelabelIcon from '@/components/Icons/WhitelabelIcon';
import { DashboardCustomizeRounded, NewLabel, TrendingUpRounded } from '@mui/icons-material';
import { ReactNode } from 'react';

interface IProps {
  className?: string;
  screen: ScreenKey;
}

const ICONS_BY_SCREEN: Partial<Record<ScreenKey, (props: IIconProps) => ReactNode>> = {
  [ScreenKey.REPORTING_DASHBOARD]: StatusUp,
  [ScreenKey.REPORTING_V2]: TrendingUpRounded,
  [ScreenKey.CUSTOM_DASHBOARDS]: DashboardCustomizeRounded,
  [ScreenKey.REPORT_BUILDER]: TaskDaily,
  [ScreenKey.PACING]: TrendingUpRounded,
  [ScreenKey.CAMPAIGN_SUBMISSION]: MegaphoneIcon,
  [ScreenKey.CAMPAIGN_MANAGEMENT]: MegaphoneIcon,
  [ScreenKey.USER_MANAGEMENT]: UserManagementRouteIcon,
  [ScreenKey.FORECASTER]: TargetIcon,
  [ScreenKey.PIXELS]: Tag,
  [ScreenKey.CREATIVE_LIBRARY]: CreativeLibraryIcon,
  [ScreenKey.WHITELABELS]: WhitelabelIcon,
  [ScreenKey.ADVERTISERS]: UserIcon,
  [ScreenKey.FIRST_PARTY_DATA]: FirstPartyDataIcon,
  [ScreenKey.AGENCIES]: BuildingIcon,
  [ScreenKey.CHANGE_LOG_HISTORY]: ChangeLogHistoryIcon,
  [ScreenKey.CLIENTS]: TvFilledIcon,
  [ScreenKey.INSIGHTS]: BrowserIcon,
  [ScreenKey.SEGMENTS]: NewLabel,
  [ScreenKey.PDF_BUILDER]: TaskDaily,
};

const SidebarRouteIcon = ({ screen, className = 'mr-[16px]' }: IProps) => {
  let Icon = ICONS_BY_SCREEN[screen];

  return Icon ? <Icon className={className} /> : null;
};

export default SidebarRouteIcon;
